import React from 'react';
import {
  Card,
  Box,
  IconButton,
  Typography,
  Chip,
  Button,
  CardActions,
  CardContent,
  CardHeader,
} from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { formatCardExpirationDate } from 'renderer/shared/formatters/formatters';
import { useAppSelector } from 'renderer/shared/state/hooks';
import { selectUserId } from 'renderer/features/auth/state/userSelectors';
import { PaymentMethod } from '../schemas/paymentMethods.schemas';
import { useEditPaymentMethodMutation } from '../services/paymentMethods.endpoints';

interface PaymentMethodCardProps {
  onEditIconClick: () => void;
  onDeleteIconClick: () => void;
  // onMakeDefaultClick: (card: any) => void;
  card: PaymentMethod;
}

const PaymentMethodCard: React.FC<PaymentMethodCardProps> = ({
  card,
  onEditIconClick,
  onDeleteIconClick,
  // onMakeDefaultClick,
}) => {
  const [updateCard, { isLoading }] = useEditPaymentMethodMutation();
  const userId = useAppSelector(selectUserId);

  const expirationDate = formatCardExpirationDate(
    card.expirationMonth ?? '',
    card.expirationYear ?? '',
  );
  return (
    <Box
      id="pmc"
      sx={{
        margin: '0 auto',
        display: 'flex',
        flexDirection: 'row',
        gap: 2,
        mt: 2,
      }}
    >
      <Card
        variant="elevation"
        sx={{
          width: 300,
          backgroundColor: 'primary.main',
          color: 'primary.contrastText',
        }}
        onClick={() => {}}
      >
        <CardHeader
          title={card.cardType}
          titleTypographyProps={{
            variant: 'h6',
          }}
        />
        <CardContent>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              marginBottom: '.5em',
            }}
          >
            <Typography>•••• •••• •••• {card.last4}</Typography>
            <Typography align="center">{expirationDate}</Typography>
          </Box>
          <Typography>{card.billingAddress.nameOnCard}</Typography>
        </CardContent>
        <CardActions>
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            {card.default ? (
              <Chip label="Default" size="small" color="info" />
            ) : (
              <Button
                size="small"
                variant="outlined"
                disabled={isLoading}
                // color="primary"
                color="inherit"
                onClick={() =>
                  updateCard({
                    id: card._id,
                    payload: { userId, default: true },
                  })
                }
              >
                Make Default
              </Button>
            )}
          </Box>
          <Box>
            <Tooltip title="Edit">
              <IconButton onClick={onEditIconClick} color="inherit">
                <EditIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Delete">
              <IconButton onClick={onDeleteIconClick} color="inherit">
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </CardActions>
      </Card>
    </Box>
  );
};

export default PaymentMethodCard;
